import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import "./css/main.css";
import { loadProgressBar } from "axios-progress-bar";
import "./css/progress.css";
import Error from "./views/Error/Error";

loadProgressBar();
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);
const axios = require("axios");

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    console.log(error.response);
    if (error.response.status === 404 || error.response.status === 500) {
      // Do something with response error
      return Promise.reject(<Error txt={error.message} />);
    } else if (error.response.status === 401 || error.response.status === 403) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      let err = error.response.data.message;
      let msg = "";
      Object.keys(err).map(function (key, index) {
        msg += err[key];
        return null;
      });
      console.log("msg", msg);

      return Promise.reject(
        <pre style={{ direction: "rtl", textAlign: "right" }}>{msg}</pre>
      );
    }

    // return <div>{error}</div>
  }
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Pages/Login"));
const Register = React.lazy(() => import("./views/Pages/Register"));
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <Route
              path="/"
              name="Home"
              render={(props) => <DefaultLayout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
